// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/icons/marevo-icon-day.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/icons/marevo-icon-night.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/img/icons/marevo-icon-reset-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/img/icons/marevo-icon-reset.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/img/icons/marevo-icon-share-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/img/icons/marevo-icon-share-hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../public/img/icons/marevo-icon-ar-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../public/img/icons/marevo-icon-ar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../public/img/icons/marevo-icon-fullscreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../public/img/icons/marevo-icon-fullscreen-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../public/img/icons/sun-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../public/img/icons/marevo-menu-blinds-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../public/img/icons/heaters-n.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.switch-container-sign {
  width: 17px;
  height: 5px;
  background-color: var(#629A33);
  border-radius: 2px;
  transform: translateX(25%) rotate(90deg);
}

.switch-container-sign--right {
  transform: rotate(0deg);
}

.input_time_switch {
  cursor: pointer;
  position: absolute;
  left: 30px;
  top: 5px;
}

#switchButton {
  width: 33px;
  height: 17px;
  border: none;
  outline: 0;
  -webkit-appearance: none;
  background-color: #629A33;
  border-radius: 100px;
  position: relative;
  align-items: center;
  display: flex;
  cursor: pointer;
}

#switchButton::after {
  content: "";
  position: absolute;
  display: flex;
  height: 90%;
  width: 45%;
  border-radius: 50%;
  background-color: #ffffff;
  align-items: center;
  right: 5%;
}

#switchButton-time {
  width: 41px;
  height: 23px;
  border-radius: 100px;
  border: 1px solid #629A33;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  right: inherit;
  -webkit-appearance: none;
}

#switchButton-time::after {
  content: "";
  position: absolute;
  display: flex;
  height: 80%;
  width: 45%;
  border-radius: 50%;
  background-color: #ffffff;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  align-items: center;
  right: 4%;
  border: 1px solid #629A33;
  background-size: contain;
  transition: all 0.3s ease;
}

#switchButton-time.switchButton-active {
  border: 1px solid #ffffff;
}

#switchButton-time.switchButton-active::after {
  left: 5%;
  right: auto;
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border: 1px solid #ffffff;
  background-size: contain;
  transition: all 0.3s ease;
}

.container_shareAR {
  display: flex;
  position: fixed;
}

.model-viewer-container {
  position: relative;
  flex: 1;
}

#ar_model_view {
  width: 100%;
  height: 100%;
}

.mainContent-3DArea {
  width: 100%;
  height: 100vh;
}

.canvas_buttons {
  position: absolute;
  top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.canvas_buttons_bottom {
  position: absolute;
  top: inherit;
  bottom: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
}

#js-toggleDayNight {
  cursor: pointer;
  display: flex;
  width: fit-content;
  background: none;
  outline: 0;
  border: 1px solid #629A33 !important;
  border-radius: 30px;
  height: fit-content;
  padding: 4px;
  color: #629A33;
  font-family: "Inter", serif;
  position: absolute;
  left: 30px;
}
#js-toggleDayNight > :first-child {
  margin-right: 8px;
}
#js-toggleDayNight label {
  cursor: pointer;
  border: 0;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: content-box;
  transition: all 0.3s;
  min-width: 40px;
  color: #629A33;
  font-family: "Inter", serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
}
#js-toggleDayNight label:hover {
  background-color: rgba(98, 154, 51, 0.3);
}
#js-toggleDayNight .night-mode {
  background-color: #ffffff;
  color: #629A33 !important;
}
#js-toggleDayNight .night-mode:hover {
  background-color: white;
}
#js-toggleDayNight .day-mode {
  background-color: #629A33;
  color: #ffffff !important;
}
#js-toggleDayNight .day-mode:hover {
  background-color: rgba(58, 58, 60, 0.5);
}

.switch--hight {
  border: 1px solid #ffffff !important;
  color: #ffffff !important;
  background-color: #629A33 !important;
}
.switch--hight .switch {
  color: #ffffff !important;
}

#menu-icon-ar-text, #menu-icon-share-text, #menu-icon-reset-text {
  font-size: 17px;
  font-weight: 300;
}

#js-resetConfig {
  cursor: pointer;
  background: none;
  display: flex;
  outline: 0;
  border: none;
  text-transform: uppercase;
  color: #629A33;
  transform: translateY(50%);
  font-family: "Inter", serif;
  font-size: 17px;
  font-weight: 300;
  line-height: 17px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: all 0.3s;
  margin-right: 30px;
}
#js-resetConfig #menu-icon-reset {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 18px;
  height: 100%;
  display: flex;
  margin-right: 8px;
}
#js-resetConfig:hover {
  color: #1A1A1A;
}
#js-resetConfig:hover #menu-icon-reset {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

#js-showModalShare {
  cursor: pointer;
  display: flex;
  background: none;
  outline: 0;
  border: none;
  text-transform: uppercase;
  transform: translateY(50%);
  font-family: "Inter", serif;
  font-size: 17px;
  font-weight: 300;
  line-height: 17px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: all 0.3s;
  color: #629A33;
  margin-right: 30px;
}
#js-showModalShare #menu-icon-share {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 18px;
  height: 100%;
  display: flex;
  margin-right: 8px;
}
#js-showModalShare:hover {
  color: #1A1A1A;
}
#js-showModalShare:hover #menu-icon-share {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

#js-showModalQRcode {
  cursor: pointer;
  background: none;
  display: flex;
  outline: 0;
  border: none;
  text-transform: uppercase;
  color: #629A33;
  transform: translateY(50%);
  font-family: "Inter", serif;
  font-size: 17px;
  font-weight: 300;
  line-height: 17px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: all 0.3s;
}
#js-showModalQRcode #menu-icon-ar {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 18px;
  height: 100%;
  display: flex;
  margin-right: 8px;
}
#js-showModalQRcode:hover {
  color: #1A1A1A;
}
#js-showModalQRcode:hover #menu-icon-ar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.full-screen {
  position: absolute;
  left: 30px;
  transition: background-image 0.3s;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  position: absolute;
  width: 32px;
  height: 32px;
  transition: all 0.3s ease;
}
.full-screen:hover {
  transform: scale(1.1);
}

.full-screen.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) !important;
  transition: all 0.3s ease;
}

.share-white {
  color: #ffffff !important;
}
.share-white::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
}

.ar-white {
  color: #ffffff !important;
}
.ar-white::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
}

.sun__icon--night {
  border-color: #ffffff !important;
}
.sun__icon--night::after {
  color: #ffffff !important;
}

.light-n {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) !important;
}

.shades-n {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) !important;
}

.heaters-n {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/model-viewer/modelViewer.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAJF;;AAOA;EACE,WAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,wCAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;EACA,yBCjCa;EDkCb,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,yBC3CY;ED4CZ,mBAAA;EACA,SAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,yBCpEY;EDqEZ,uBAAA;EACA,yDAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,QAAA;EACA,WAAA;EACA,yBCrFY;EDsFZ,yDAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;AAJF;;AAQA;EACE,aAAA;EACA,eAAA;AALF;;AAQA;EACE,kBAAA;EACA,OAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;AALF;;AAQA;EACE,WAAA;EACA,aAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AALF;;AAQA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AALF;;AAQA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cCjJa;ECIb,2BAAA;EFgJA,kBAAA;EACA,UAAA;AANF;AAQE;EACE,iBAAA;AANJ;AASE;EACE,eAAA;EACA,SAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EAEA,cCrKW;EC8Db,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AFgGF;AAOI;EACE,wCAAA;AALN;AASE;EACE,yBCzKU;ED0KV,yBAAA;AAPJ;AASI;EACE,uBAAA;AAPN;AAWE;EACE,yBCvLW;EDwLX,yBAAA;AATJ;AAWI;EACE,uCAAA;AATN;;AAcA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AAXF;AAaE;EACE,yBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,gBAAA;AAZF;;AAeA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,cCtNa;EDuNb,0BAAA;EEnNA,2BAAA;EFsNA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,oBAAA;EACA,kBAAA;AAbF;AAgBE;EACE,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,cC7OW;AD8Nf;AAkBE;EACE,yDAAA;AAhBJ;;AAoBA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EE3PA,2BAAA;EF8PA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,oBAAA;EACA,cCzQa;ED0Qb,kBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,cCrRW;ADkQf;AAsBE;EACE,yDAAA;AApBJ;;AAwBA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,cCvSa;EDwSb,0BAAA;EEpSA,2BAAA;EFuSA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,oBAAA;AAtBF;AAwBE;EACE,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,cC5TW;ADqSf;AA0BE;EACE,yDAAA;AAxBJ;;AA4BA;EACE,kBAAA;EAEA,UAAA;EACA,iCAAA;EACA,eAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AA1BF;AA4BE;EACE,qBAAA;AA1BJ;;AA+BA;EACE,oEAAA;EACA,yBAAA;AA5BF;;AA+BA;EACE,yBAAA;AA5BF;AA8BE;EACE,oEAAA;AA5BJ;;AAgCA;EACE,yBAAA;AA7BF;AA+BE;EACE,oEAAA;AA7BJ;;AAiCA;EACE,gCAAA;AA9BF;AAgCE;EACE,yBAAA;AA9BJ;;AAkCA;EACE,qEAAA;AA/BF;;AAkCA;EACE,qEAAA;AA/BF;;AAkCA;EACE,qEAAA;AA/BF","sourcesContent":["@use \"../../styles/variables\" as vars;\n@use \"../../styles/mixins\" as mixins;\n\n$primary-color: #007bff;\n\n.switch-container {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.switch-container-sign {\n  width: 17px;\n  height: 5px;\n  background-color: var(vars.$second-color);\n  border-radius: 2px;\n  transform: translateX(25%) rotate(90deg);\n}\n\n.switch-container-sign--right {\n  transform: rotate(0deg);\n}\n\n.input_time_switch {\n  cursor: pointer;\n  position: absolute;\n  left: 30px;\n  top: 5px;\n}\n\n#switchButton {\n  width: 33px;\n  height: 17px;\n  border: none;\n  outline: 0;\n  -webkit-appearance: none;\n  background-color: vars.$second-color;\n  border-radius: 100px;\n  position: relative;\n  align-items: center;\n  display: flex;\n  cursor: pointer;\n}\n\n#switchButton::after {\n  content: \"\";\n  position: absolute;\n  display: flex;\n  height: 90%;\n  width: 45%;\n  border-radius: 50%;\n  background-color: vars.$white-color;\n  align-items: center;\n  right: 5%;\n}\n\n#switchButton-time {\n  width: 41px;\n  height: 23px;\n  border-radius: 100px;\n  border: 1px solid vars.$second-color;\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  right: inherit;\n  -webkit-appearance: none;\n}\n\n#switchButton-time::after {\n  content: \"\";\n  position: absolute;\n  display: flex;\n  height: 80%;\n  width: 45%;\n  border-radius: 50%;\n  background-color: vars.$white-color;\n  justify-content: center;\n  background-image: url(/public/img/icons/marevo-icon-day.svg);\n  align-items: center;\n  right: 4%;\n  border: 1px solid vars.$second-color;\n  background-size: contain;\n  transition: all .3s ease;\n}\n\n#switchButton-time.switchButton-active {\n  border: 1px solid vars.$white-color;\n}\n\n#switchButton-time.switchButton-active::after {\n  left: 5%;\n  right: auto;\n  background-color: vars.$white-color;\n  background-image: url(/public/img/icons/marevo-icon-night.svg);\n  border: 1px solid vars.$white-color;\n  background-size: contain;\n  transition: all .3s ease;\n}\n\n\n.container_shareAR {\n  display: flex;\n  position: fixed;\n}\n\n.model-viewer-container {\n  position: relative;\n  flex: 1;\n}\n\n#ar_model_view {\n  width: 100%;\n  height: 100%;\n}\n\n.mainContent-3DArea {\n  width: 100%;\n  height: 100vh;\n}\n\n.canvas_buttons {\n  position: absolute;\n  top: 20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.canvas_buttons_bottom {\n  position: absolute;\n  top: inherit;\n  bottom: 70px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n#js-toggleDayNight {\n  cursor: pointer;\n  display: flex;\n  width: fit-content;\n  background: none;\n  outline: 0;\n  border: 1px solid vars.$second-color !important;\n  border-radius: 30px;\n  height: fit-content;\n  padding: 4px;\n  color: vars.$second-color;\n\n  @include mixins.font-family();\n  position: absolute;\n  left: 30px;\n\n  &> :first-child {\n    margin-right: 8px;\n  }\n\n  label {\n    cursor: pointer;\n    border: 0;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    box-sizing: content-box;\n    transition: all 0.3s;\n    min-width: 40px;\n\n    color: vars.$second-color;\n    @include mixins.bold;\n\n    &:hover {\n      background-color: rgba($color: vars.$second-color, $alpha: 0.3);\n    }\n  }\n\n  .night-mode {\n    background-color: vars.$white-color;\n    color: vars.$second-color !important;\n\n    &:hover {\n      background-color: rgba($color: vars.$white-color, $alpha: 1);\n    }\n  }\n\n  .day-mode {\n    background-color: vars.$second-color;\n    color: vars.$white-color !important;\n\n    &:hover {\n      background-color: rgba($color: vars.$black-color-second, $alpha: 0.5);\n    }\n  }\n}\n\n.switch--hight {\n  border: 1px solid vars.$white-color !important;\n  color: vars.$white-color !important;\n  background-color: vars.$second-color !important;\n\n  .switch {\n    color: vars.$white-color !important;\n  }\n}\n\n#menu-icon-ar-text, #menu-icon-share-text, #menu-icon-reset-text {\n  font-size: 17px;\n  font-weight: 300;\n}\n\n#js-resetConfig {\n  cursor: pointer;\n  background: none;\n  display: flex;\n  outline: 0;\n  border: none;\n  text-transform: uppercase;\n  color: vars.$second-color;\n  transform: translateY(50%);\n\n  @include mixins.font-family();\n  font-size: 17px;\n  font-weight: 300;\n  line-height: 17px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  transition: all 0.3s;\n  margin-right: 30px;\n\n\n  #menu-icon-reset {\n    content: \"\";\n    background-image: url(../../../public/img/icons/marevo-icon-reset-active.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 18px;\n    height: 100%;\n    display: flex;\n    margin-right: 8px;\n  }\n\n  &:hover {\n    color: vars.$black-color;\n  }\n\n  &:hover #menu-icon-reset {\n    background-image: url(../../../public/img/icons/marevo-icon-reset.svg);\n  }\n}\n\n#js-showModalShare {\n  cursor: pointer;\n  display: flex;\n  background: none;\n  outline: 0;\n  border: none;\n  text-transform: uppercase;\n  transform: translateY(50%);\n\n  @include mixins.font-family();\n  font-size: 17px;\n  font-weight: 300;\n  line-height: 17px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  transition: all 0.3s;\n  color: vars.$second-color;\n  margin-right: 30px;\n\n  #menu-icon-share {\n    content: \"\";\n    background-image: url(../../../public/img/icons/marevo-icon-share-active.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 18px;\n    height: 100%;\n    display: flex;\n    margin-right: 8px;\n  }\n\n  &:hover {\n    color: vars.$black-color;\n  }\n\n  &:hover #menu-icon-share {\n    background-image: url(../../../public/img/icons/marevo-icon-share-hover.svg);\n  }\n}\n\n#js-showModalQRcode {\n  cursor: pointer;\n  background: none;\n  display: flex;\n  outline: 0;\n  border: none;\n  text-transform: uppercase;\n  color: vars.$second-color;\n  transform: translateY(50%);\n\n  @include mixins.font-family();\n  font-size: 17px;\n  font-weight: 300;\n  line-height: 17px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  transition: all 0.3s;\n\n  #menu-icon-ar {\n    content: \"\";\n    background-image: url(../../../public/img/icons/marevo-icon-ar-active.svg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 18px;\n    height: 100%;\n    display: flex;\n    margin-right: 8px;\n  }\n\n  &:hover {\n    color: vars.$black-color;\n  }\n\n  &:hover #menu-icon-ar {\n    background-image: url(../../../public/img/icons/marevo-icon-ar.svg);\n  }\n}\n\n.full-screen {\n  position: absolute;\n  // bottom: 70px;\n  left: 30px;\n  transition: background-image 0.3s;\n  cursor: pointer;\n  background-image: url(../../../public/img/icons/marevo-icon-fullscreen.svg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  transition: all .3s ease;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n\n.full-screen.active {\n  background-image: url(../../../public/img/icons/marevo-icon-fullscreen-active.svg) !important;\n  transition: all .3s ease;\n}\n\n.share-white {\n  color: vars.$white-color !important;\n\n  &::before {\n    background-image: url(../../../public/img/icons/marevo-icon-share-active.svg) !important;\n  }\n}\n\n.ar-white {\n  color: vars.$white-color !important;\n\n  &::before {\n    background-image: url(../../../public/img/icons/marevo-icon-ar-active.svg) !important;\n  }\n}\n\n.sun__icon--night {\n  border-color: vars.$white-color !important;\n\n  &::after {\n    color: vars.$white-color !important;\n  }\n}\n\n.light-n {\n  background-image: url(../../../public/img/icons/sun-icon.svg) !important;\n}\n\n.shades-n {\n  background-image: url(../../../public/img/icons/marevo-menu-blinds-active.svg) !important;\n}\n\n.heaters-n {\n  background-image: url(../../../public/img/icons/heaters-n.svg) !important;\n}","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
